import { Map } from "immutable";
export function mutateState(
  map: any,
  mutator: (map: any) => any
): any {
  return Map(map)
    .withMutations(mutator)
    .toJS();
}
